import { render, staticRenderFns } from "./CadastroProjeto.vue?vue&type=template&id=d8c7007c&"
import script from "./CadastroProjeto.vue?vue&type=script&lang=js&"
export * from "./CadastroProjeto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports